module.exports = __webpack_public_path__ + "img/Custom.eb7343e9.svg";